import { useEffect, useMemo, useRef, useState } from 'react'
import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue } from '../../../interface/steps.interface'
import { IStringInputSettings, StringVariants } from '../inputs.interface'
// import useLocalStatus from '../../../module/hooks/useLocalStatus/useLocalStatus';
import { useChangeHook } from './useChangeHook';

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  status: IInputStatus
  settings: IStringInputSettings
  checkChangeValue: Function
  progressTrigger?: Function
}
export const useDefaultString = ({
  value,
  name,
  handleChange,
  status,
  settings,
  checkChangeValue,
  progressTrigger
}: Props) => {
  const { isValidate, placeholder } = settings

  // const [localValue, setLocalValue] = useState<string>(value)
  // const [localStatus, setLocalStatus] = useState<IInputStatus>(IInputStatus.none)
  // const [focused, setFocused] = useState<boolean>(false)
  const [localPlaceholder, setLocalPlaceholder] = useState<string>(
    placeholder ?? ''
  )

  const inputRef = useRef<HTMLInputElement>(null)

  const {
    localValue,
    localStatus,
    handleLocalChange,
    handleKeydown,
    handleBlur,
    focused,
    setFocused
  } = useChangeHook({
    value,
    name,
    handleChange,
    inputRef,
    status,
    checkChangeValue,
    progressTrigger
  })

  // const {
  //   localStatus,
  //   changeStatusHandler,
  //   setChangeStatusHandler
  // } = useLocalStatus({
  //   value,
  //   status,
  //   focused
  // })

  useEffect(() => {
    console.log('useEffect focus', focused)
    if (!focused) {
      inputRef?.current?.blur()
    }
  }, [focused])

  // useEffect(() => {

  //   if (
  //     !focused &&
  //     (status === IInputStatus.apiError
  //     || status === IInputStatus.error)
  //   ) {
  //     setLocalStatus(status)
  //   } else if ( status === IInputStatus.success && !focused) {
  //     setLocalStatus(IInputStatus.success)
  //   } else {
  //     // setLocalStatus(status)
  //   }
  //   console.log('useEffect', status, localStatus)
  // }, [status])

  // useEffect(() => {
  //   setLocalValue(value)
  // }, [value])

  // useEffect(() => {
  //   console.log('handleChange')
  //   handleChange(name, localValue, isValidate)
  // }, [localValue])

  useEffect(() => {
    try {
      // Устанавить placeholder в зависимости от фокуса
      if (focused) {
        setLocalPlaceholder(placeholder ?? '')
      } else {
        setLocalPlaceholder('')
      }
    } catch (error) {
      console.log(error)
    }
  }, [focused])

  const localSettings = useMemo(
    () => ({
      ...settings,
      variant: StringVariants.default,
      placeholder: localPlaceholder,
    }),
    [localPlaceholder]
  )
  const disabled = useMemo(() => status === IInputStatus.disabled, [status])

  // const handleLocalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   try {
  //     const value = event.target.value
  //     setLocalValue(value)
  //     setChangeStatusHandler()
  //     // setLocalStatus(IInputStatus.change)
  //     checkChangeValue(name)
  //     // handleChange(name, value, isValidate)
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  // const handleKeydown = (event: any) => {
  //   console.log(event.key)
  //   if (event.key === 'Enter') {
  //     setFocused(false)
  //     handleChange(name, localValue, true)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   } else if (event.key === 'Escape') {
  //     setFocused(false)
  //     setLocalValue(value)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   }
  // }

  const handlePaste = () => { }

  const handleFocus = () => {
    // Установить флаг фокуса
    setFocused(true)
  }
  // const handleBlur = () => {
  //   if (!focused) {
  //     // Снять флаг фокуса
  //     setFocused(false)
  //     // Установить статус инпута
  //     changeStatusHandler()
  //     handleChange(name, localValue, true)
  //     if (progressTrigger) {
  //       progressTrigger()
  //     }
  //   }
  //   // if (value !== '' && (status === IInputStatus.apiError || status === IInputStatus.error)) {
  //   //   setLocalStatus(status)
  //   // } else if (value !== '' && status === IInputStatus.success) {
  //   //   setLocalStatus(IInputStatus.success)
  //   // } else {
  //   //   setLocalStatus(IInputStatus.change)
  //   // }
  //   // handleChange(name, localValue, isValidate)
  // }

  return {
    localValue,
    localStatus,
    inputRef,
    disabled,
    localSettings,
    handleLocalChange,
    handleKeydown,
    handlePaste,
    handleFocus,
    handleBlur,
  }
}
